module.exports = __webpack_public_path__ + "images/home/orientation/up-next.6b180fd2d4526f7925c9.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/home/orientation/up-next.svg
// module id = EvAL
// module chunks = 13